import { useMemo } from "react"

import { sanitizeData } from "@l2r-front/l2r-geodata"
import { useTranslation } from "@l2r-front/l2r-i18n"
import { Source, useMapDispatchContext } from "@l2r-front/l2r-map"

import { I18N_NAMESPACE } from "../../../../common/constants/i18n"
import { useRiskZoneClusters } from "../../hooks/queries/useRiskZoneClusters"

export function RiskZonesSource(props) {

    const { t } = useTranslation(I18N_NAMESPACE)
    const { setError: setMapError } = useMapDispatchContext()

    const { data: riskZoneClusters } = useRiskZoneClusters({
        as_geojson: true,
    }, {
        onError: () => setMapError(true),
        errorSnackbarMessage: t(I18N_NAMESPACE, "containers.riskZoneClusterSource.error"),
    })

    // Need to copy id into properties because of that mapbox issue: 
    // link:https://github.com/mapbox/mapbox-gl-js/issues/2716
    const sanitizedData = useMemo(() => {
        if (!riskZoneClusters) {
            return null
        }

        return sanitizeData(riskZoneClusters)
    }, [riskZoneClusters])

    return (
        <Source {...props} type="geojson" data={sanitizedData} tolerance={.001} />
    )
}

RiskZonesSource.propTypes = Source.propTypes